<template>
    <div>
        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
            <div class="row justify-content-end">
                <div class="col-auto pt-2">
                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                </div>
                <div class="col-auto">
                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 overflow-auto">
                    <b-table small striped hover bordered :fields="fields" :items="attendanceItems" responsive="sm">
                        <template #cell(index)="data">
                            {{ data.index + startPage }}
                        </template>
                        <template #cell(icon)="data">
                            <img class="profile-image-md rounded-circle" :src="data.item.icon != '' ? getImage(data.item.icon) : require('@/assets/image/icon/profile.png')"/>
                        </template>
                        <template #cell(outletID)="data">
                            {{getOutletName(data.item.outletID)}}
                        </template>
                        <template #cell(duration)="data">
                            <span v-if="getDuration(data.item.duration) == 'Present'" class="badge badge-primary">{{$t('salon_report.attendance.present')}}</span>
                            <span v-else class="badge badge-warning">{{getDuration(data.item.duration)}}</span>
                        </template>
                        <template #cell(entryDate)="data">
                            {{convertTimestampToDateTime(data.item.entryDate)}}
                        </template>
                        <template #cell(exitDate)="data">
                            {{data.item.exitDate == 0 ? '-' : convertTimestampToDateTime(data.item.exitDate)}}
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {handleSessionExpired, setReturnData, getOutletName} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "attendanceList",
    data(){
        return{
            isSpinnerShow: false,
            filterObj: {},
            outlet: [],
            attendanceItems: {},
            exportData: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#", thClass: 'thead-themed align-middle'},
                {key: "icon", label: "", tdClass: 'text-center', thClass: 'thead-themed align-middle'},
                {key: "name", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "username", label: this.$i18n.t('table.header.username'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "outletID", label: this.$i18n.t('table.header.outlet'), thClass: 'thead-themed align-middle'},
                {key: "duration", label: this.$i18n.t('table.header.working_hour'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "entryDate", label: this.$i18n.t('table.header.clock_in'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "exitDate", label: this.$i18n.t('table.header.clock_out'), thClass: 'thead-themed align-middle', sortable: true},
            ]
        }, 
        exportField(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.name')).toUpperCase()] = "name"
            ret[(this.$i18n.t('table.header.username')).toUpperCase()] = "username"
            ret[(this.$i18n.t('table.header.outlet')).toUpperCase()] = "outlet"
            ret[(this.$i18n.t('table.header.working_hour')).toUpperCase()] = "duration"
            ret[(this.$i18n.t('table.header.clock_in')).toUpperCase()] = "entryDate"
            ret[(this.$i18n.t('table.header.clock_out')).toUpperCase()] = "exitDate"
            return ret
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.exportData)
        }
    },
    methods:{
        convertTimestampToDateTime(date){
            return moment(date*1000).format(this.$msg.CST.DATE_TIME_24)
        },
        getImage(img){
            return img;
        },
        getDuration(strDuration){
            var result = ""
            var arrDuration = strDuration.split(":")
            var hr = arrDuration[0]
            var min = arrDuration[1]

            if(hr.indexOf('-') != -1){
                result = "Present"
            }else{
                hr = parseInt(hr)
                if(hr > 24){
                    var d = Math.floor(hr/24);
                    var rm = hr % 24;
                    hr = Math.floor(rm);

                    result =  d + " Days " + hr + " Hr " + min + " Mins"    
                }else{
                    result = hr + " Hr " + min + " Mins"
                }
            }
            return result
        },
        getOutletName(id){
            return getOutletName(id, this.outlet)
        },
        async setAttendanceItems(filterObj){
            this.filterObj = filterObj;           
            var dateFilter = ""
            if(filterObj.dateType != 'all'){
                dateFilter = filterObj.dateType == "entry" ? 
                "&startEntryDate=" + moment(filterObj.date.startDate).unix() + "&endEntryDate=" + moment(filterObj.date.endDate).unix() :
                "&startExitDate=" + moment(filterObj.date.startDate).unix() + "&endExitDate=" + moment(filterObj.date.endDate).unix() 
            }

            var staffFilter = filterObj.staffID.id == "all" || filterObj.staffID.id == undefined ? "" : "&staffID=" + filterObj.staffID.id
            var typeFilter = filterObj.type == "all" ? "" : "&status=" + filterObj.type

            var strFilter = dateFilter + staffFilter + typeFilter;
            
            this.isSpinnerShow = true
            var retData = await this.getAttendanceItems(filterObj.outletID, strFilter)
            var result = setReturnData(retData, this.totalEntries, this.page)
            this.attendanceItems = result.result;
            this.totalPage = result.totalPage;

            this.startPage = result.startPage;
            this.endPage = result.endPage;
            this.isSpinnerShow = false;

            if(filterObj.staffID.id == "all" ){
                this.$emit('setStaffFilter', result.result, filterObj.staffID)
            }
            await this.getExportData(filterObj.outletID, strFilter)
        },
        async getAttendanceItems(outletID, strFilter){
            let $vm = this;
            let QUERY_STRING = "/" + outletID + this.$api.REPORT_ATTENDANCE + "?page=" + this.page +  strFilter
            const url =  this.$api.OUTLET + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
                $vm.totalEntries = response.data.count;              
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getExportData(outletID, strFilter){
            let $vm = this;
            let QUERY_STRING = "/" + outletID + this.$api.REPORT_ATTENDANCE + "?" + strFilter
            const url =  this.$api.OUTLET + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result           
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.exportData = result
            this.setExportData(result)
        },
        setExportData(data){
            var strDate = moment(this.filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

            if(this.filterObj.dateType == "all"){
                strDate = " ("+ this.$i18n.t('salon_report.attendance.all_date_types') + ")"
            }else{
                var dateType = this.$i18n.messages[this.$i18n.locale].salon_report.attendance.option_date_filter
                var strDateType = dateType.filter(obj=> obj.value == this.filterObj.dateType)[0].text

                strDate = " (" + strDateType + ": "
                + moment(this.filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT) + ")";
            }

            let header = this.$msg.REPORT.HEADER  + this.$i18n.t('subMenu.salon_report_attendance') + strDate
            var exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];

            var exportFileName = header.split(" ").join("_") +  this.$msg.REPORT.CSV

            var exportData = []
            for(var i=0; i<data.length; i++){
                exportData.push({
                    index: i+1,
                    name: data[i].name,
                    username: data[i].username,
                    outlet: this.getOutletName(data[i].outletID),
                    duration: this.getDuration(data[i].duration),
                    entryDate: this.convertTimestampToDateTime(data[i].entryDate),
                    exitDate: data[i].exitDate == 0 ? "-" : this.convertTimestampToDateTime(data[i].exitDate),
                })
            }

            var exportObj = {
                data: exportData,
                fields: this.exportField,
                headers: exportHeaders,
                fileName: exportFileName
            }
            
            this.$emit('setExportData', exportObj)
        },
        async handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                await this.setAttendanceItems(this.filterObj);
            }
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
   }
}
</script>
